import classNames from 'classnames';
import * as React from 'react';
import { ReactElement } from 'react';
import FormItem from '../__partials/form-item';
import HelpText from '../__partials/help-text';
import Label from '../__partials/label';
import './style.css';

type IProps = {
  label?: string;
  status?: 'default' | 'error' | 'success';
  statusText?: string;
  helpText?: any;
  isDisabled?: boolean;
  isRequired?: boolean;
  className?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = ({
  label,
  status = 'default',
  statusText,
  helpText,
  isDisabled,
  isRequired,
  className,
  id = 'input',
  ...props
}: IProps): ReactElement => {
  const inputClasses = classNames('input', {
    [`${className}`]: className,
  });

  return (
    <FormItem status={status} isDisabled={isDisabled}>
      {label && <Label label={label} statusText={statusText} id={id} />}
      <div className="input__wrapper">
        <input
          {...props}
          id={id}
          className={inputClasses}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          aria-required={isRequired}
        />
      </div>
      {helpText && <HelpText text={helpText} status={status} />}
    </FormItem>
  );
};

export default Input;
